import React, {PropTypes} from 'react';
import {reduxForm, Field} from 'redux-form';
import StandardField from 'shared/StandardField.jsx';
import StandardModal from 'shared/StandardModal.jsx';
import ErrorListContainer from 'shared/error/ErrorListContainer.jsx';
import DisplayIf from 'shared/DisplayIf.jsx';
import VirtualEntryContainer from './VirtualEntryContainer.jsx';

export const EntryCaptainChangeForm = ({
  visible,
  isNew,
  submitButtonText,
  affectedVirtualEntries,
  allAffectedVirtualEntriesSelected,
  onCancelClick,
  handleSubmit,
  onSubmit,
  onSearchClick,
  onSelectAllChecked
}) =>
( 
  <StandardModal
    title="Change Captain"
    visible={visible}
    onCloseClick={onCancelClick}
    bodyOverflow>
    <form onSubmit={handleSubmit(onSubmit)}>
      <ErrorListContainer />
      <div className="row">
        <div className="col-sm-12">
          <Field name="captainEmail"
            type="text"
            component={StandardField}
            placeholder="Email"/>
        </div>
      </div>
        <div className="form-group text-right">
          <button
            type="button"
            className="btn btn-lg"
            onClick={onSearchClick}
          ><i className="fa fa-search" /> {'Search'}</button>
        </div>
      <div className="row">
        <div className="col-sm-6">
          <Field name="captainFirstName"
            disabled={!isNew}
            type="text"
            component={StandardField}
            placeholder="First Name"/>
        </div>
        <div className="col-sm-6">
          <Field name="captainLastName"
            disabled={!isNew}
            type="text"
            component={StandardField}
            placeholder="Last Name"/>
        </div>
        <DisplayIf condition={affectedVirtualEntries && affectedVirtualEntries.length > 0}>
          <div className="col-sm-12">
            <hr />
            <div style={{paddingTop: 20, paddingBottom: 20}}>
              {'The following virtual entries will be affected by this move. Please review them and mark the ones you would like to move as well:'}
            </div>
            <div className="list-group-item-labeled-child custom-checkbox-container"
              style={{width: 250}}>
              <input
                type="checkbox"
                id={`selectAllAffected`}
                checked={allAffectedVirtualEntriesSelected}
                onChange={() => onSelectAllChecked()}
              />
              <label
                htmlFor={`selectAllAffected`}>
                Select All
              </label>
            </div>
            <div className="list-group">
              {affectedVirtualEntries.filter(entry => entry.entryName !== null).map((item, index) => (
                <div key={index}>
                  <VirtualEntryContainer {...item} />
                </div>
              ))}
              {affectedVirtualEntries.filter(entry => entry.bowlerName !== null).map((item, index) => (
                <div key={index}>
                  <VirtualEntryContainer {...item} />
                </div>
              ))}
            </div>
          </div>
        </DisplayIf>
      </div>
      <div className="form-group text-right">
        <button
          type="button"
          className="btn btn-link"
          onClick={() => onCancelClick()}
        >Cancel</button>
        {` `}
        <button
          type="submit"
          className="btn btn-primary btn-lg"
        ><i className="fa fa-floppy-o" /> { submitButtonText }</button>
      </div>
    </form>
  </StandardModal>
);

EntryCaptainChangeForm.propTypes = {
  visible: PropTypes.bool,
  isNew: PropTypes.bool,
  submitButtonText: PropTypes.string,
  affectedVirtualEntries: PropTypes.arrayOf(PropTypes.object),
  allAffectedVirtualEntriesSelected: PropTypes.bool,
  onCancelClick: PropTypes.func,
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onSearchClick: PropTypes.func,
  onSelectAllChecked: PropTypes.func
};

export default reduxForm({
  form: 'adminEntryCaptainChangeForm'
})(EntryCaptainChangeForm);



// WEBPACK FOOTER //
// ./src/features/admin/entryDetail/EntryCaptainChangeFormModal.jsx